<template>
    <div  class="color" :class="{'color-ski': isSkiEvent, 'color-snowman': isSnowmanEvent}">
        <article class="add" :class="{'background-ski': isSkiEvent, 'background-snowman': isSnowmanEvent}">

            <h1>{{ $t('landing_consent_title_landing') }}</h1>

            <p>{{ $t('landing_consent_subtitle_description') }}</p>

            <a href="#privacy" v-show="isWinter" class="winter-anchor">{{ $t('landing_consent_your_data') }}</a>

            <div class="wrapper">

                <div class="bloc bloc-first">

                    <span class="text">{{ $t('landing_consent_tuto_1') }}</span>
                    <span class="descrition">{{ $t('landing_manual_setting') }}</span>

                    <input :placeholder="$t('landing_email_placeholder')" ref="inputv4" type="email"
                           v-on:keyup.enter="goLoginEvent($refs.inputv4.value, 'connect_email')">
                    <button @click.prevent="goLoginEvent($refs.inputv4.value, 'connect_email')">
                        <span v-show="!requesting">{{ $t('global_validate') }}</span>
                        <lottie-loader v-show="requesting" :size="22"></lottie-loader>
                    </button>

                </div>

                <div class="or"><span>{{ $t('generic_or') }}</span></div>

                <div class="bloc">

                    <span class="text">{{ $t('scan_qr_code') }}</span>
                    <span class="descrition">{{ $t('test_without_download') }}</span>

                    <div class="mini-apps">
                        <div class="app-clip">
                            <img src="/img/partner/qr-code-app-clip-1.svg">
                        </div>

                        <div class="instant-app">
                            <q-r-code-instant-app :big="true"></q-r-code-instant-app>
                        </div>
                    </div>

                </div>

                <img src="/img/seasonal/winter/foxy-ski.svg" class="foxy-ski" v-show="isSkiEvent">

            </div>

            <a href="#privacy" v-show="!isWinter"
               :class="{'winter-anchor': isSkiEvent}">{{ $t('landing_consent_your_data') }}</a>

            <img src="/img/seasonal/winter/foxy-snowman.svg" class="foxy-snowman" v-show="isSnowmanEvent">

        </article>
    </div>
</template>

<script>
import Vuex from 'vuex'

import LottieLoader from '../../components/lottie/LottieLoader'
import QRCodeInstantApp from '../../components/landing/QRCodeInstantApp'
import ENUM from '../../assets/ENUM'

export default {

    name: 'article-1-desktop-default',

    props: {
        requesting: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'seasonalEvent'
        ]),

        isSkiEvent() {
            return this.seasonalEvent === ENUM.SEASONAL.WINTER.WINTER_SKI
        },

        isSnowmanEvent() {
            return this.seasonalEvent === ENUM.SEASONAL.WINTER.WINTER_SNOWMAN
        },

        isWinter() {
            return !!this.seasonalEvent
        }
    },

    components: {
        LottieLoader,
        QRCodeInstantApp
    },
    mounted() {

        setTimeout(() => {
            if (this.$route.query && this.$route.query.email) {
                this.$refs.inputv4.value = this.$route.query.email
            }
        }, 500)

    },

    methods: {

        goLoginEvent(email, event) {
            this.$emit('goLogin', email, event)
        }
    }
}
</script>

<style lang="scss" scoped>

.add {
    padding: 113px 16px 35px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background-image: url('/img/background/landing-v4-desktop-background.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    > h1 {
        font-size: 36px;
        font-weight: bold;
        line-height: 1.14;
    }

    > p {
        margin-top: 16px;
        font-size: 22px;
        font-weight: 500;
        line-height: 1.4;
        max-width: 866px;
    }

    .wrapper {
        max-width: 1440px;
        margin-top: 65px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        @media screen and (min-width: 1248px) {
            flex-direction: row;
            align-items: normal;
        }

        .bloc {
            padding: 40px 32px 32px;
            border-radius: 16px;
            box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.04), 0 4px 16px 0 rgba(0, 0, 0, 0.08);
            background-color: $white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            color: $black;
            flex: 1;

            .text {
                font-size: 24px;
                font-weight: 600;
                line-height: 1.17;
            }

            .descrition {
                margin-top: 8px;
                font-size: 17px;
                line-height: 1.41;
            }

            .mini-apps {
                margin-top: 24px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                @media screen and (min-width: 1248px) {
                    margin-top: 10px;
                }

                &:lang(ar-sa) {
                    flex-direction: row-reverse;
                }

                > div {
                    width: 256px;
                    background-color: #32a3eb;
                    border-radius: 40px;
                    height: 315px;
                    display: flex;
                }

                .app-clip {
                    margin-right: 12px;

                }

                .instant-app {
                    margin-left: 12px;
                    padding: 28px;
                    align-items: center;
                }
            }

            input {
                margin-top: 40px;
                width: 100%;
                padding: 22px 24px;
                border-radius: 32px;
                border: solid 2px $silver;
                font-size: 16px;
                font-weight: 500;
                line-height: 1.4;
                text-align: start;
            }

            button {
                width: 100%;
                margin-top: 8px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 16px 24px;
                border-radius: 32px;
                background-color: $lime;
                font-size: 17px;
                font-weight: 600;
                line-height: 1.41;
                color: $white;

                &:hover {
                    background-color: $green-hover;
                }

                &:active {
                    background-color: $green-active;
                }
            }
        }

        .bloc-first {
            width: 100%;
            max-width: 500px;
            padding: 112px 32px;
            @media screen and (min-width: 1248px) {
                max-width: inherit;
            }
        }

        .or {
            margin: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            font-weight: bold;
            line-height: 1.25;
        }
    }

    a {
        margin-top: 48px;
        font-size: 17px;
        font-weight: 600;
        line-height: 1.41;
        text-align: center;
        color: $midnight;
        cursor: pointer;
    }
}

.bloc {
    z-index: 1;
}

.color {
    background-color: $blue;
}
//SEASONAL

.color-ski {
    background: linear-gradient(180deg, #2C6096 0%, #011C38 100%);
}

.color-snowman {
    background: linear-gradient(180deg, #153F5F 0%, #0B1330 100%);
}

.background-ski {
    position: relative;
    background-image: url('/img/seasonal/winter/background-tablet-ski.svg');
    @media screen and (min-width: 1248px) {
        background-image: url('/img/seasonal/winter/background-desktop-ski.svg');
    }
    background-position: bottom;
    padding-bottom: 160px;
    color: $white;
}

.background-snowman {
    position: relative;
    padding-bottom: 160px;
    color: $white;
    background-image: url('/img/seasonal/winter/background-tablet-snowman.svg');
    @media screen and (min-width: 1248px) {
        background-image: url('/img/seasonal/winter/background-desktop-snowman.svg');
    }
}

.foxy-ski {
    width: 190px;
    position: absolute;
    left: 0px;
    bottom: -150px;
    z-index: 1;
}

.foxy-snowman {
    width: 220px;
    position: absolute;
    bottom: 4px;
    z-index: 1;
}

.add .winter-anchor {
    color: $white;
    margin-top: 24px;
}


</style>

